export * from './reg-exp/is-reg-exp.js';
